import { defineMessages } from 'react-intl';

export default defineMessages({
  claimDescription: {
    id: 'graphql.ClaimListItem.desc',
    defaultMessage: 'Claim Description:',
  },
  pendingValidation: {
    id: 'graphql.AssignmentListItem.pendingValidations',
    defaultMessage: 'Pending validation',
  },
  indorsed: {
    id: 'graphql.AssignmentListItem.indorsed',
    defaultMessage: 'Recommended',
  },
  flagged: {
    id: 'graphql.AssignmentListItem.flagged',
    defaultMessage: 'Not Recommended',
  },
  viewFeedback: {
    id: 'graphql.AssignmentListItem.viewFeedback',
    defaultMessage: 'View validators feedback',
  },
  votingExpiry: {
    id: 'graphql.AssignmentListItem.votingExpiry',
    defaultMessage: 'Voting Expiry:',
  },
  noConsensus: {
    id: 'graphql.ClaimListItem.noConsensus',
    defaultMessage: 'No Consensus',
  },
  claimDisapproved: {
    id: 'graphql.ClaimListItem.claimDisapproved',
    defaultMessage: 'Claim Disapproved',
  },
});
